import { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import { companyMasterListAsync } from "../../../../redux/features/company-master/companyMasterSlice";
import toast from "react-hot-toast";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { kiloleterMasterListAsync } from "../../../../redux/features/kiloleter-master/kiloleterMasterSlice";
import { removeKiloleterMasterAsync } from "../../../../redux/features/kiloleter-master/deleteKiloleteMasterSlice";

export default function KiloleterMasterList() {
   const dispatch = useDispatch();
   const kiloleterMasterList = useSelector(
      (state) => state.kiloleterMasterListSlice.data,
   );

   const [records, setRecords] = useState([]);
   const columns = [
      {
         name: "Kiloleter Value",
         selector: (row) => row.kiloleter_value,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button className="btn" onClick={() => handleDelete(row.id)}>
                     <BsTrashFill
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
               </div>
            );
         },
      },
   ];

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         kiloleterMasterListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   }, []);

   useEffect(() => {
      if (kiloleterMasterList) setRecords(kiloleterMasterList);
   }, [kiloleterMasterList]);

   const handleDelete = (id) => {
      const confirmDelete = window.confirm(
         "Are you sure you want to delete this Kiloleter?",
      );

      if (!confirmDelete) return;

      dispatch(backdropLoadingAction(true));

      dispatch(
         removeKiloleterMasterAsync({
            id,
            done: () => {
               dispatch(backdropLoadingAction(false));
               toast.success("Kiloleter deleted successfully");

               // Refresh list after delete
               dispatch(kiloleterMasterListAsync({}));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = kiloleterMasterList?.filter((item) => {
         return item?.kiloleter_value?.toLowerCase().includes(searchText);
      });
      setRecords(newData);
   };

   return (
      <div>
         <BodyHeader title="Kiloleter Master List" />

         <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
